import React from "react";
import s from './Content.module.css'
import {Table} from "./Table/Table";
import ErrorHandleContainer from "../ErrorPopup/ErrorHandleContainer";


const Content = (props) => {
    return (
        <div className={s.content}>
            {props.data.data.contentData.isErrorPopupShow && <ErrorHandleContainer/>}
            {/*<div>*/}

            {/*</div>*/}
            <div className={s.wrapper}>
                <Table/>
            </div>
            {/*<div>*/}

            {/*</div>*/}
        </div>
    )
};

export default Content;